import fiSwapSuggestionActions from "../../../actions/fiSwapSuggestionActions";
import fiSwapSuggestionTableColumns, {
  fiSwapSuggestionTableLeftFixedColumns,
} from "./fiSwapSuggestionTableColumns";
import generateEntityTable from "../../../hocs/generateEntityTable";

const FiSwapSuggestionsTable = generateEntityTable({
  entityPluralString: "fiSwapSuggestions",
  entityActions: fiSwapSuggestionActions,
  columns: fiSwapSuggestionTableColumns,
  leftFixedColumns: fiSwapSuggestionTableLeftFixedColumns,
  // operations: [],
  copyFiSwapSuggestionTextOperation: true,
});

export default FiSwapSuggestionsTable;
